import { BaseModel } from 'paliari-js-utils'

const attrs = () => ({
  id: null,
  aliquota: 0,
  ano: null,
  base_calculo: 0,
  cadastro_economico_id: null,
  cancelada: false,
  codigo_art: '',
  codigo_cnae: '',
  codigo_obra: '',
  codigo_tributacao_id: null,
  codigo_tributo_municipal: '',
  codigo_verificacao: '',
  competencia: null,
  contribuinte: {},
  contribuinte_id: null,
  created_at: null,
  declarado_id: null,
  declarado_intermediario_id: null,
  declarante_id: null,
  desconto_condicionado: 0,
  desconto_incondicionado: 0,
  discriminacao: '',
  doc_dados: {},
  doc_dados_id: null,
  exigibilidade_iss: '',
  url: '',
  url_qr_code: '',
  guia_id: null,
  incentivo_cultural: false,
  incentivo_fiscal: false,
  intermediario_id: null,
  lista_servico: {},
  lista_servico_id: null,
  municipio_incidencia: {},
  municipio_incidencia_id: null,
  municipio_prestacao_id: null,
  nfe_situacao_tomador_id: null,
  nfe_status_id: null,
  nfe_status: null,
  nfe_substituida_id: null,
  numero: null,
  outras_informacoes: '',
  outras_retencoes: 0,
  pais_id: null,
  permite_cancelar: false,
  permite_recusar: false,
  prestador: {},
  prestador_id: null,
  processo_exigibilidade_suspenso: '',
  projeto_id: null,
  regime_especial_id: null,
  rps_emitido_em: null,
  rps_lote_id: null,
  rps_numero: null,
  rps_serie: '',
  rps_tipo: null,
  serie: '',
  simples: false,
  situacao: {},
  regime_especial: { descricao: 'Nenhum' },
  situacao_id: null,
  tipo_recolhimento: '',
  tomador_id: null,
  updated_at: null,
  usuario_id: null,
  valor_cofins: 0,
  valor_credito: 0,
  valor_csll: 0,
  valor_deducoes: 0,
  valor_inss: 0,
  valor_ir: 0,
  valor_iss: 0,
  valor_iss_retido: 0,
  valor_liquido_nfse: 0,
  valor_pis: 0,
  valor_servicos: 0
})

export default class Nfe extends BaseModel {
  constructor(obj) {
    super(attrs(), obj)
  }
}
